import Styled from 'styled-components';

export const Caption = Styled.small`
  font-size: 1.4rem;
  color: ${({ theme: { text } }) => text.colorCaption};
`;

Caption.displayName = 'Caption';
